const jsPopup = {
    init() {
        $('.popup').map(function () {
            const id = $(this).attr('id');
            if (!window.sessionStorage.getItem(id)) {
                $(this).show();
            }

            $(this)
                .find('.popup-close')
                .click(() => {
                    $(this).hide();
                    window.sessionStorage.setItem(id, 'true');
                });
        });
    },
};
